import { defineStore } from 'pinia';

export const useLoadingStore = defineStore('loading', {
  state: () => ({
    active: {}
  }),
  getters: {
    isVisible(state) {
      return Object.keys(state.active).length > 0;
    }
  },
  actions: {
    show(key = 'global') {
      this.active[String(key)] = true;
    },
    hide(key = 'global') {
      delete this.active[String(key)];
    },
    set(key = 'global', value = false) {
      if (value) {
        this.show(key);
        return;
      }
      this.hide(key);
    },
    clear() {
      this.active = {};
    }
  }
});
